/**
 * 素材审核模块
 */
import _ from 'lodash'

export const reasons = [
  {
    label: '【未规范添加风险提示声明】',
    content:
      '金融行业收益类产品，广告素材中需添加风险提示声明：请勿轻易转让资金或提供您的个人信息，根据个人能力谨慎投资，历史收益数据仅供参考。',
    value: 10,
  },
  {
    label: '【未规范添加风险提示声明】',
    content:
      '真金类广告内容应当规范添加风险提示声明，该声明必须被清晰、完整展示，如为视频或试玩广告，必须全程展示该声明。风险提示声明内容：不保证最终结果，您所能获取的金额以APP或网页内公布的规则为准。请谨慎游戏，谨防成瘾。',
    value: 6,
  },
  {
    label: '【未规范添加风险提示声明】',
    content:
      '任务赚钱类广告内容应当规范添加风险提示声明，该声明必须被清晰、完整展示，如为视频或试玩广告，必须全程展示该声明。风险提示声明内容：不保证最终结果，您所能获取的金额以APP或网页内公布的规则为准。',
    value: 5,
  },
  {
    label: '【涉嫌虚假宣传】',
    content: '您的广告内容涉嫌虚假宣传，或包含可能误导用户的内容。',
    value: 11,
  },
  {
    label: '【涉嫌宣传引人不适的内容】',
    content:
      '您的广告内容涉嫌宣传消极、丑陋、恐怖、血腥、暴力、不文明以及可能引起用户不适的内容。',
    value: 3,
  },
  {
    label: '【推广的产品不明确】',
    content: '您的广告内容导向的一跳落地页无法打开，请确认。',
    value: 12,
  },
  {
    label: '【素材质量不符合规范】',
    content:
      '您的广告内容存在画质模糊、不完整、翻译错误、长度或格式等不符合技术参数等质量问题。',
    value: 9,
  },
  {
    label: '【素材质量不符合规范】',
    content: '您的广告内容视频时长大于120秒，请调整素材时长并重新上传。',
    value: 13,
  },
  {
    label: '【广告创意与推广产品无关联性】',
    content: '您的广告内容与所推广的产品不具有关联性或关联性较低。',
    value: 14,
  },
  {
    label: '【不当的成人内容】',
    content:
      '您的广告内容可能包含过于暴露、动作不雅、暗示或隐含性信息的形象或物化女性或男性的内容。',
    value: 1,
  },
  {
    label: '【不当的涉政内容】',
    content:
      '您的广告内容可能使用或涉及某些国家的机关、领导人、民族和种族等损害其国家和社会利益及形象的内容。',
    value: 2,
  },
  {
    label: '【涉嫌虚假诱导点击】',
    content:
      '您的广告内容中包含可能诱导或误导用户点击的文案、虚假按钮、虚假倒计时、虚假手势、虚假仿系统功能类按钮等元素。',
    value: 15,
  },
  {
    label: '【交互素材技术报错】',
    content:
      '因技术性错误被拒审，原因为：XXX，请参照交互素材规范指南和提示进行修改。',
    value: 7,
  },
  {
    label: '【不符合投放地法律的规定】',
    content:
      '您的广告内容违反了投放地广告法等相关法律法规的规定，如有疑问，您可咨询Mintegral的客户支持团队。',
    value: 8,
  },
  {
    label: '【涉嫌侵犯他人合法权益】',
    content:
      '您的广告存在可能侵犯他人的肖像权、著作权、商标权（Paypay等）等其他知识产权或合法权益的内容，请提供商标授权证明。',
    value: 16,
  },
  {
    label: '【违反Mintegral的广告政策】',
    content:
      '您的广告内容导向apk文件或apk文件下载页，Mintegral禁止推广apk文件。',
    value: 17,
  },
  {
    label: '【违反Mintegral的广告政策】',
    content:
      '您的广告内容违反了Mintegral的广告政策，如有疑问，您可咨询Mintegral的客户支持团队。',
    value: 18,
  },
  {
    label: '【未规范添加风险提示声明】',
    content:
      '承诺奖励类广告内容应当规范添加风险提示声明，该声明必须被清晰、完整展示，如为视频或试玩广告，必须全程展示该声明。风险提示声明内容：任何涉及给与礼物、奖励、权益等的承诺均以网页所载规则为准，有任何问题请联系网页或App的主办方。',
    value: 19,
  },
  {
    label: '【未规范添加风险提示声明】',
    content:
      '电商产品广告内容应当规范添加风险提示声明，该声明必须被清晰、完整展示，声明如下 <br/>医疗产品：请仔细阅读产品说明书或者在医务人员的指导下购买和使用。 <br/>化妆及护肤品：使用效果因人而异。 <br/>保健品和膳食补充剂：保健食品不是药物,不能用于治疗、诊断、治愈、预防任何疾病,效果因人而异.  <br/>减肥功效的产品：使用效果因人而异"或"减肥需要结合运动,效果存在个体差异。',
    value: 20,
  },
  {
    label: '【推广内容的合规性存疑】',
    content:
      '您的广告内容可能存在合规性问题。请您提供有效的牌照、许可或其他相关文件，以证明您的应用及广告内容在投放地区的合规性。',
    value: 21,
  },
  {
    label: '【不当的宗教内容】',
    content: '您的广告内容可能包含不当的或容易引发争议的宗教符号、标签或元素。',
    value: 22,
  },
  {
    label: '【其他原因】',
    content: '',
    value: 99,
  },
]

export const rejectReason = [
  {
    label: '【未规范添加风险提示声明】',
    value: '10,6,5,19,20',
  },
  {
    label: '【涉嫌虚假宣传】',
    value: '11',
  },
  {
    label: '【涉嫌宣传引人不适的内容】',
    value: '3',
  },
  {
    label: '【推广的产品不明确】',
    value: '12',
  },
  {
    label: '【素材质量不符合规范】',
    value: '9,13',
  },
  {
    label: '【广告创意与推广产品无关联性】',
    value: '14',
  },
  {
    label: '【不当的成人内容】',
    value: '1',
  },
  {
    label: '【不当的涉政内容】',
    value: '2',
  },
  {
    label: '【涉嫌虚假诱导点击】',
    value: '15',
  },
  {
    label: '【不符合投放地法律的规定】',
    value: '8',
  },
  {
    label: '【涉嫌侵犯他人合法权益】',
    value: '16',
  },
  {
    label: '【违反Mintegral的广告政策】',
    value: '17,18',
  },
  {
    label: '【推广内容的合规性存疑】',
    value: '21',
  },
  {
    label: '其他',
    value: '99',
  },
]

export const creativeType = [
  {
    value: 1,
    label: 'graphic',
  },
  {
    value: 2,
    label: 'video',
  },
  {
    value: 3,
    label: 'playable 2D',
  },
  {
    value: 4,
    label: 'playable 3D',
  },
  {
    value: 5,
    label: '动态endcard',
  },
  {
    value: 6,
    label: 'interactive video',
  },
  {
    value: 7,
    label: 'panoramic',
  },
  {
    value: 8,
    label: 'playable dco',
  },
]

export const advEntity = [
  {
    value: 'Mintegral',
    label: 'Mintegral',
  },
  {
    value: 'MV',
    label: 'MV',
  },
  {
    value: 'Juntai',
    label: 'Juntai',
  },
]

export const offerType = [
  {
    value: 1,
    label: 'direct',
  },
  {
    value: 2,
    label: 'direct-MTG',
  },
  {
    value: 3,
    label: 'indirect_manual',
  },
  {
    value: 4,
    label: 'indirect-API',
  },
]

export const offerCategory = [
  {
    value: 'uuid',
    label: 'offer uuid',
  },
  {
    value: 'name',
    label: 'offer name',
  },
]

export const creativeCategory = [
  {
    value: 'id',
    label: 'creative id',
  },
  {
    value: 'name',
    label: 'creative name',
  },
  {
    value: 'review_id',
    label: 'ID',
  },
]

export const AIRecognitionResult = [
  {
    value: 1,
    label: '待机审',
  },
  {
    value: 2,
    label: '通过',
  },
  {
    value: 3,
    label: '违规（涉黄）',
  },
  {
    value: 4,
    label: '违规（涉政）',
  },
  {
    value: 5,
    label: '违规（暴恐）',
  },
  {
    label: '违规（含不相关第三方平台信息）',
    value: 6,
  },
]

export const remarkOptions = [
  {
    value: 1,
    label: '特批',
  },
  {
    value: 2,
    label: '复议',
  },
]

export const materialGrading = [
  {
    value: 1,
    label: '4+',
  },
  {
    value: 2,
    label: '9+',
  },
  {
    value: 3,
    label: '12+',
  },
  {
    value: 4,
    label: '17+',
  },
  {
    value: 5,
    label: '诱导',
  },
  {
    value: 6,
    label: '引人不适',
  },
  {
    value: 7,
    label: '关联性低',
  },
  {
    value: 8,
    label: '没问题',
  },
  {
    value: 9,
    label: '放行',
  },
  {
    value: 10,
    label: '系统诱导',
  },
]

export const materialGradingMap = {
  1: {
    value: 1,
    label: '4+',
  },
  2: {
    value: 2,
    label: '9+',
  },
  3: {
    value: 3,
    label: '12+',
  },
  4: {
    value: 4,
    label: '17+',
  },
  5: {
    value: 5,
    label: '诱导',
  },
  6: {
    value: 6,
    label: '引人不适',
  },
  7: {
    value: 7,
    label: '关联性低',
  },
  8: {
    value: 8,
    label: '没问题',
  },
  9: {
    value: 9,
    label: '放行',
  },
  10: {
    value: 10,
    label: '系统诱导',
  },
}
export const getGradingLabel = (str) => {
  const values = str.split(',')
  const res = []
  for (const s of values) {
    res.push(materialGradingMap[s].label)
  }
  return res.join(',')
}

export const priorityOptions = [
  {
    value: 0,
    label: 0,
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
]

export const auditResultOptions = [
  {
    label: 'Approved',
    value: 3,
  },
  {
    label: 'Rejected',
    value: 2,
  },
]

export const cookSearchParams = (params) => {
  const cloneParams = _.pick(params, [
    'page',
    'page_size',
    'status',
    'campaign_name',
    'offer_type',
    'adv_name',
    'creative_type',
    'from_platform',
    'is_dco',
    'adv_entity',
    'pm_teams',
    'pm',
    'ai_status_in',
    'reason_ids',
    'platform',
    'search_time',
    'time',
    'offer_geo',
    'creative_geo',
    're_review',
    'app_name',
    'package_name',
    'adv_grade',
    'creative_name',
    'creative_id_unique',
    'remark',
    'material_gradings',
    'priority',
    'audit_remarks',
    'draft_operator',
    'uniq_adv_pkg_md5',
  ])

  // offer
  if (params.offer_field === 'uuid') {
    cloneParams.offer_uuid = params.offer_field_value
  } else {
    cloneParams.offer_name = params.offer_field_value
  }

  // creative
  if (params.creative_field === 'id') {
    cloneParams.creative_id = params.creative_id
  } else if (params.creative_field === 'review_id') {
    cloneParams.id = params.id
  } else {
    cloneParams.creative_name = params.creative_name
  }
  const status = params.status

  // 如果 status 不是 1-8 中的一个，改成 1
  if (
    ![1, '2,3', 4, 5, 6, 7, 8].some(
      (item) => item === status || item === Number(status),
    )
  ) {
    //  status为offer，默认为空
    if (status === 'offer') {
      delete cloneParams.status
      delete cloneParams.search_time
      delete cloneParams.time
    } else {
      cloneParams.status = 1
    }
  }
  // pending 状态是 pm，rejected 与 approved 是 operator
  if (
    ['2,3', 4, 5].some((item) => item === status || item === Number(status))
  ) {
    cloneParams.operator = params.operator
  }

  // Audit result页面增加审核意见筛选
  if (params.audit_result) {
    cloneParams.status = params.audit_result
  }
  // Audit result页面增加是否经过复审筛选
  if (params.review) {
    cloneParams.review = params.review
  }

  // Re-Review页面增加优先级筛选
  if (params.priority && status === 7) {
    cloneParams.priority = params.priority
  } else {
    cloneParams.priority = ''
  }

  cloneParams.creative_id_unique = status === '2,3' ? 1 : ''

  // 过滤素材关联OFFER查询参数
  if (status === 'offer') {
    return {
      all_creative_name: 1,
      creative_name: cloneParams.creative_name,
      page: cloneParams.page,
      page_size: cloneParams.page_size,
    }
  }
  return cloneParams
}

export const spliceAuditReasons = (
  reasonIds,
  reasonMap,
  reasonList = reasons,
) => {
  let cookedReason = []

  if (reasonIds) {
    cookedReason = reasonIds.split(',').map((item) => {
      const temp = _.cloneDeep(
        reasonList.filter((reason) => reason.value === Number(item))[0],
      )

      if (temp && temp.value === 99) {
        temp.content = reasonMap[99]
      }
      if (temp && temp.value === 8) {
        temp.content = temp.content.replace('XXX', reasonMap[8])
      }
      if (temp && temp.value === 7) {
        temp.content = temp.content.replace('XXX', reasonMap[7])
      }
      return temp
    })
  }

  return cookedReason
}

export const convertCreativeType = (type) => {
  const list = creativeType.filter((typeItem) => {
    if (typeItem.value === Number(type)) return true
    return false
  })
  return list.length ? list[0].label : 'other'
}

// 判断审核内容是否playable/endcard
export const isPlayable = (type) => {
  if (type) {
    return (
      Number(type) === 3 ||
      Number(type) === 4 ||
      Number(type) === 5 ||
      Number(type) === 6 ||
      Number(type) === 7 ||
      Number(type) === 8 ||
      type === 'playable 2D' ||
      type === 'playable 3D' ||
      type === '动态endcard' ||
      type === 'interactive video' ||
      type === 'panoramic' ||
      type === 'playable dco'
    )
  }
  return false
}
